export const fileJson =
    [
        {
            title: "think about it!",
            img: "1.png",
            desc: "identifies the route"
        },
        {
            title: "<code_it />",
            img: "7.png",
            desc: "See and solve the problem"
        },
        {
            title: "develop it.",
            img: "4.png",
            desc: "Implement the source code"
        }
    ]

export const main_title = {title: "development mindset"}

